// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasMusic: CreateIconOptions = {
  "displayName": "FASMusic",
  "viewBox": "0, 0, 512, 512",
  "d": "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7l0 72 0 264c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L448 147 192 223.8 192 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6L128 200l0-72c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
};
